class ContentSelect extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-select-button]');
    this.list = this.querySelector('[data-select-list]');
    this.hiddenInput = this.querySelector('[data-select-input]');

    this.button.addEventListener('click', () => this.toggle());
    this.list.addEventListener('click', (e) => this.handleSelect(e));
    this.list.addEventListener('close', () => this.handleClose());

    this.initSelected();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updatePosition);
    window.removeEventListener('scroll', this.updatePosition, true);
  }

  initSelected() {
    const selected =
      this.list.querySelector('[data-selected]') ||
      (this.hiddenInput?.value &&
        this.list.querySelector(`[data-value="${this.hiddenInput.value}"]`));

    if (selected) {
      selected.setAttribute('data-selected', '');
      this.button.innerHTML = selected.innerHTML;
      if (this.hiddenInput) this.hiddenInput.value = selected.dataset.value;
    }
  }

  positionDialog() {
    const rect = this.button.getBoundingClientRect();
    const vv = window.visualViewport;
    const spacing = 8;

    const viewportHeight = vv?.height || window.innerHeight;
    const offsetLeft = vv?.offsetLeft || 0;
    const offsetTop = vv?.offsetTop || 0;

    const spaceBelow = viewportHeight - (rect.top - offsetTop + rect.height) - spacing;
    const spaceAbove = rect.top - offsetTop - spacing;
    const left = Math.min(
      Math.max(rect.left - offsetLeft, spacing),
      (vv?.width || window.innerWidth) - rect.width - spacing
    );

    const showBelow = spaceBelow >= 200 || spaceBelow >= spaceAbove;

    Object.assign(this.list.style, {
      position: 'fixed',
      left: `${left + offsetLeft}px`,
      width: `${rect.width}px`,
      margin: '0',
      zIndex: '9999',
      top: showBelow ? `${rect.bottom + spacing}px` : 'auto',
      bottom: showBelow ? 'auto' : `${viewportHeight - rect.top + spacing + offsetTop}px`,
      maxHeight: `${Math.min((showBelow ? spaceBelow : spaceAbove) - spacing, 400)}px`,
    });
  }

  toggle() {
    if (this.list.open) {
      this.list.close();
    } else {
      this.positionDialog();
      this.list.showModal();
      this.button.ariaExpanded = 'true';

      this.updatePosition = () => this.positionDialog();
      window.addEventListener('resize', this.updatePosition);
      window.addEventListener('scroll', this.updatePosition, true);
    }
  }

  handleClose() {
    this.button.ariaExpanded = 'false';
    window.removeEventListener('resize', this.updatePosition);
    window.removeEventListener('scroll', this.updatePosition, true);
  }

  handleSelect(e) {
    const option = e.target.closest('[data-value]');
    if (!option) return;

    this.list
      .querySelectorAll('[data-selected]')
      .forEach((el) => el.removeAttribute('data-selected'));
    option.setAttribute('data-selected', '');
    this.button.innerHTML = option.innerHTML;

    if (this.hiddenInput) {
      this.hiddenInput.value = option.dataset.value;
      this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.list.close();
  }
}

customElements.define('content-select', ContentSelect);
